import { Navigate } from "react-router-dom"
import { useAuth } from "@/components/layout/AuthProvider"
import { useEffect, useState } from "react"
import { supabaseClient } from "@/lib/supabase/client"
import { PostCard } from "@/components/post/PostCard"
import { FeedSkeleton } from "@/components/feed/FeedSkeleton"

export default function FollowingPage() {
  const { supabaseUser } = useAuth()
  const [posts, setPosts] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!supabaseUser) return
    supabaseClient.from("posts")
      .select("*, users(id,username,display_name,avatar_url,is_verified), post_topics(topics(id,name,slug))")
      .eq("status", "published")
      .order("created_at", { ascending: false })
      .limit(30)
      .then(({ data }) => { setPosts(data || []); setLoading(false) })
  }, [supabaseUser?.id])

  if (!supabaseUser) return <Navigate to="/auth/login" replace />
  if (loading) return <FeedSkeleton />

  return (
    <div className="container-narrow py-4">
      <h1 className="font-bold text-xl mb-4">Following</h1>
      {posts.length === 0 ? (
        <div className="text-center py-16 text-text-muted">Follow people to see their posts here</div>
      ) : posts.map(post => (
        <PostCard key={post.id} post={post} userId={supabaseUser.id} />
      ))}
    </div>
  )
}